'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var HeaderRow = require('../HeaderRow/HeaderRow.js');
var styledComponents = require('./styled-components.js');

var TableWithHeader = function (props) {
    var headCells = props.headCells, children = props.children, footer = props.footer, _a = props.dense, dense = _a === void 0 ? false : _a, _b = props.withoutHeader, withoutHeader = _b === void 0 ? false : _b;
    var size = dense ? 'small' : 'medium';
    return (React__default.createElement(styledComponents.TableContainer, null,
        React__default.createElement(core.Table, { size: size },
            !withoutHeader && (React__default.createElement(core.TableHead, null,
                React__default.createElement(HeaderRow, { headCells: headCells }))),
            React__default.createElement(core.TableBody, null, children),
            footer)));
};

module.exports = TableWithHeader;
